import { reducer } from './modules';

export { default as areaActions } from './modules';
export { default as areaSaga } from './sagas';
export { default as areaSelectors } from './selectors';
export { default as areaOperations } from './operations';

export default reducer;
